export default {
  apiKey: "AIzaSyDHyOMRLXKbW5qBoNZ2X_hyl_0H60B-ZTY",
  authDomain: "dealzy-b0be7.firebaseapp.com",
  projectId: "dealzy-b0be7",
  storageBucket: "dealzy-b0be7.firebasestorage.app",
  messagingSenderId: "736341742612",
  appId: "1:736341742612:web:a044ddba9f76e7da264301",
  measurementId: "G-78JM2KHVT1",
};
